import styled from "styled-components";

export const FormGroup = styled.div`
  margin: 0.5rem 0;
  display: flex;
  flex-direction: column;

  input {
    border: none;
    outline: none;
    padding: 0.5rem;
    border-radius: 5px;
    border: 1px solid #c8cccf;
  }
  select {
    background-color: transparent;
    border: 1px solid #c8cccf;
    padding: 8px;
    border-radius: 5px;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  margin: 6px 0px;
  color: ${({ theme }) => theme.text};
`;

export const Field = styled.input``;
